import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { ConfigService } from '../core/config/config.service';
import { ApiError } from '../models/api-error.model';
import { tokenEstaExpirado } from '../core/utils/token.util';
import { AuthService } from '../services/auth.service';

function codigoDe(erro: HttpErrorResponse): string | undefined {
  return (erro.error as Partial<ApiError> | null)?.code;
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const apiUrl = inject(ConfigService).settings()?.apiUrl;

  const token = auth.getToken();
  const paraApi = !!apiUrl && req.url.startsWith(apiUrl);
  const requisicao =
    token && paraApi ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

  return next(requisicao).pipe(
    catchError((erro: unknown) => {
      if (erro instanceof HttpErrorResponse && erro.status === 401 && tokenEstaExpirado(token)) {
        auth.logout();
        void router.navigate(['/login']);
      }
      if (erro instanceof HttpErrorResponse && erro.status === 403 && codigoDe(erro) === '403-03') {
        // Troca de senha obrigatória: mantém a sessão e leva à tela de troca.
        void router.navigate(['/conta/senha']);
      }
      return throwError(() => erro);
    }),
  );
};
